import { AuditJobRequest } from '../../Models/Api/strongbox.financialportal';

import { StartAuditJob as StartAuditJobService } from '../../Services/AuditService';

import { LogException } from '../../Utils/Logging';

import { AppThunkActionAsync } from '../index';
import { KnownAction as uiKnownActions, actionCreators as uiStateActions } from '../UIState';
import {
    RunAuditWorkpapersActions,
    IShowRunAuditWorkpapersModal,
    IHideRunAuditWorkpapersModal,
    KnownAction,
} from './Actions';

function ShowRunAuditWorkpapersModal(workspaceId: string, submissionId: string, financialRecordId: string): IShowRunAuditWorkpapersModal {
    return {
        type: RunAuditWorkpapersActions.ShowModal,
        workspaceId,
        submissionId,
        financialRecordId,
    };
}

function HideRunAuditWorkpapersModal(): IHideRunAuditWorkpapersModal {
    return {
        type: RunAuditWorkpapersActions.HideModal,
    };
}

/**
 * Starts an audit job (called when the user confirms the Run Audit Workpapers modal). Shows the global
 * working indicator, then closes the modal on success. Returns whether the job started.
 */
const StartAuditJob = (request: AuditJobRequest): AppThunkActionAsync<boolean, KnownAction | uiKnownActions> =>
    async (dispatch): Promise<boolean> => {
        const workingName = `StartAuditJob`;

        dispatch(uiStateActions.SetPortalWorking(workingName));

        try {
            await StartAuditJobService(request);

            dispatch({ type: RunAuditWorkpapersActions.HideModal });

            return true;
        } catch (e) {
            const errorMsg = 'Starting audit job action creator failed';

            console.error(errorMsg);
            console.error(e);

            LogException(errorMsg, e);

            return false;
        } finally {
            dispatch(uiStateActions.SetPortalIdle(workingName));
        }
    }

export const actionCreators = {
    ShowRunAuditWorkpapersModal,
    HideRunAuditWorkpapersModal,
    StartAuditJob,
};
